import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Button as CustomButton } from '@components/index';
import { fonts } from '@theme/fontsCustomer';

export const Container = styled(Box)`
  width: 100%;
  height: 100%;
`;

export const NoProdcutContainer = styled(Box)`
  display: flex;
  flex-direction: column;
`;

export const Categories = styled(Box)`
  max-width: 988px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
`;

export const Products = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 40px 20px;
  flex-wrap: wrap;
`;

export const NoProduct = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 380px;
  background-color: ${({ theme: { colors } }) => colors['bg-white']};
  border: 1px solid ${({ theme: { colors } }) => colors['border-gray-lighter']};
  align-items: center;
  padding: 90px 0px 106px 0px;

  & .main-text {
    ${fonts.Headline7};
    color: ${({ theme: { colors } }) => colors['text-gray-main']};
    margin-bottom: 4px;
  }

  & .sub-text {
    ${fonts.Body2};
    color: ${({ theme: { colors } }) => colors['text-gray-sub-dark']};
    margin-bottom: 40px;
  }
`;

export const Exclaim = styled(Box)`
  display: flex;
  flex-direction: row;
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background-color: ${({ theme: { colors } }) => colors['bg-primary-lighter']};
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`;

export const Button = styled(CustomButton)`
  height: 30px;
  border-radius: 16px;
  padding: 0 16px;
  position: relative;
  &.contain {
    ${fonts.Button4};
    border: 1px solid ${({ theme }) => theme.colors['bg-primary']};
  }
`;

export const StyledSwiper = styled(Swiper)`
  width: 100%;
  position: relative;
  button:not([disabled]).category-selected {
    background-color: ${({ theme }) => theme.colors['bg-primary']};
    border-color: ${({ theme }) => theme.colors['border-primary']};
    color: ${({ theme }) => theme.colors['text-white']};
  }
  button.arrow {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
    border: none;
    background: none;
    &:hover span {
      border-color: ${({ theme }) => theme.colors['state-white-primary-hover']};
      background-color: ${({ theme }) => theme.colors['state-white-primary-hover']};
      svg path {
        fill: ${({ theme }) => theme.colors['bg-primary']};
      }
    }
    span {
      width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0.5px solid rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      background-color: ${({ theme }) => theme.colors['bg-white']};
      z-index: 100;
    }
    &.swiper-button-prev {
      left: 0;
      z-index: 100;
      &:before {
        content: '';
        display: block;
        width: 50px;
        height: 32px;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        background: linear-gradient(270deg, rgba(250, 251, 252, 0) 0%, #fafbfc 50%);
      }
      &.swiper-button-disabled {
        display: none;
        &:before {
          content: none;
        }
      }
    }
    &.swiper-button-next {
      right: 0;
      z-index: 100;
      &:after {
        content: '';
        display: block;
        width: 60px;
        height: 32px;
        position: absolute;
        right: -2px;
        top: 0;
        z-index: 1;
        background: linear-gradient(90deg, rgba(250, 251, 252, 0) 0%, #fafbfc 50%);
      }
      &.swiper-button-disabled {
        display: none;
        &:after {
          content: none;
        }
      }
    }
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  width: auto !important;
`;
